<template>
<div class="kne-modal-backdrop" @click.self="close()">
    <transition name="slide-fade">
        <div v-if="init" class="card col-12 col-md-8 offset-md-2 kne-modal">
            <h4 v-if="title || closable" class="card-title text-center py-2 px-3">
                <span v-if="title">{{title}}</span>
                <button v-if="closable" type="button" class="close" aria-label="Close" @click="close('x')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </h4>
            <div class="card-block px-0 pt-0">
                <slot></slot>
            </div>
        </div>
    </transition>
</div>
</template>

<script>
  export default{
    data () {
      return {
        init: false
      }
    },
    props: {
      title: {
        type: String,
        requiered: false
      },
      closable: {
        type: Boolean,
        requiered: false
      },
      closableBackdrop: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      close: function (origin) {
        if (this.closableBackdrop) this.$emit('close-request')
        if (origin === 'x') this.$emit('close-request')
      }
    },
    mounted () {
      this.init = true
      document.body.style.overflow = 'hidden'
    },
    destroyed () {
      document.body.style.overflow = 'auto'
    }
  }
</script>

<style scoped>
    .card{
        border:none;
        /*min-height: 32rem;*/
    }
    .kne-modal-backdrop{
        position: fixed;
        background-color: rgba(0,0,0,.5);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9001;
    }
    .kne-modal{
        top: 10%;
        /*overflow:auto;*/
        max-height: 80%;
        padding: 0px;
    }
    .card-block{
        overflow-y: auto;
        overflow-x: hidden;
    }
    .card-title>span{
        color: rgba(19, 19, 19, 0.6);
    }
    @media (max-width: 767px){
        .kne-modal{
            top: .5rem;
            max-height: 95%;
        }
    }
    .slide-fade-enter-active, .slide-fade-leave-active{
        transition: all 500ms;
    }
    .slide-fade-enter, .slide-fade-leave-to{
        opacity: 0;
        transform: translateY(20px);
    }
</style>



// WEBPACK FOOTER //
// Modal.vue?f76cc5a8